import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import currencyFormatter from 'currency-formatter';

@Injectable({
  providedIn: 'root'
})
export class FechaFunctionsService {

  constructor() { }

  TimeNow() {
    const now = new Date();
    const hours = this.padZero(now.getHours());
    const minutes = this.padZero(now.getMinutes());
    const seconds = this.padZero(now.getSeconds());
    return `${hours}:${minutes}:${seconds}`;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  rangeYear() {
    const max = new Date().getFullYear()
    const min = 2022
    const years = []

    for (let i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  addDays(date: Date, days: number): Date {
    date.setDate(date.getDate() + days);
    return date;
  }

  Today(withTime = false): Date {
    let today = new Date();
    if (!withTime) today.setHours(0, 0, 0, 0);
    return today;
  }

  DateFormated(date: Date): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL');
      return datepipe.transform(date, 'dd/MM/yyyy')
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  DateTimeFormated(date: Date): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL');
      return datepipe.transform(date, 'dd/MM/yyyy HH:mm')
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  DateTimeSecondFormated(date: Date): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL');
      return datepipe.transform(date, 'dd/MM/yyyy HH:mm:ss')
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  DateFormatedBD(date: string): Date {
    try {
      let d = date.split('/')
      return new Date(d[2] + "-" + d[1] + "-" + d[0])
    } catch (e) {
      return null;
    }
  }

  DateFormatedBD_toString(date: string): string {
    try {
      let d = date.split('/')
      return d[2] + "-" + d[1] + "-" + d[0]
    } catch (e) {
      return null;
    }
  }

  DateFormatedBDTimeZero(date: string): Date {
    try {
      let d = date.split('/')
      return new Date(d[2] + "-" + d[1] + "-" + d[0] + "T00:00:00")
    } catch (e) {
      console.error(e);
      return null;
    }
  }

  NowDay(): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL');
      const DateNow = new Date();
      const localDate = new Date(DateNow.getTime() - (DateNow.getTimezoneOffset() * 60000));
      /* return datepipe.transform(DateNow.toISOString().slice(0, 10), 'dd/MM/yyyy') */
      return localDate.toISOString().slice(0, 10);
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  NowDayFormated(): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL');
      const DateNow = new Date();
      return datepipe.transform(DateNow.toISOString(), 'dd/MM/yyyy')
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  NextDay(): string {
    try {
      const DateNow = new Date();
      const localDate = new Date(DateNow.getTime() - (DateNow.getTimezoneOffset() * 60000));
      const nextDay = new Date(localDate.getTime() + 24 * 60 * 60 * 1000);
      return nextDay.toISOString().slice(0, 10);
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  NextDayFormated(): string {
    try {
      const datepipe: DatePipe = new DatePipe('es-CL')
      const DateNow = new Date();
      const nextDay = new Date(DateNow.getTime() + 24 * 60 * 60 * 1000);
      return datepipe.transform(nextDay.toISOString(), 'dd/MM/yyyy')
    } catch (e) {
      console.error(e);
      return '';
    }
  }

  currencyPeso(val): string {
    return currencyFormatter.format(Number(val), {
      symbol: '$',
      decimal: ',',
      thousand: '.',
      precision: 0,
      format: '%s%v' // %s is the symbol and %v is the value
    });
  };

  formatPedido(val): string {
    return `SL${val.toString().padStart(8, '0')}`;
  }

  formatTelefono(val): string {
    if (val == null || val == "") return ""
    const fono = (val).replace("+", "");
    if (fono.length != 11) return '+' + fono
    return '+' + fono.substr(0, 2) + ' ' + fono.substr(2, 1) + ' ' + fono.substr(3, 4) + ' ' + fono.substr(7, 4);
  }
}